import * as HoverOverPrimitive from '@radix-ui/react-hover-card';
import React from 'react';
import styles from './HoverOver.module.scss';

export type HoverOverProps = React.ComponentPropsWithoutRef<typeof HoverOverPrimitive.Root> & {
  trigger: React.ReactElement;
  /** Contents of this dropdown */
  children: React.ReactNode;
  onEscapeKeyDown?: (event: KeyboardEvent) => void;
};

export const HoverOver = (props: HoverOverProps) => {
  const { trigger, children, ...rest } = props;

  const handleEscapeKeyDown = (event: KeyboardEvent) => {
    props.onOpenChange?.(false);
    props?.onEscapeKeyDown?.(event);
  };

  return (
    <HoverOverPrimitive.Root {...rest}>
      <HoverOverPrimitive.Trigger asChild>{trigger}</HoverOverPrimitive.Trigger>
      <HoverOverPrimitive.Portal>
        <HoverOverPrimitive.Content
          arrowPadding={4 * 4}
          collisionPadding={4 * 4}
          onEscapeKeyDown={handleEscapeKeyDown}
          className={styles.HoverOverContent}
        >
          {children}
          <HoverOverPrimitive.Arrow className={styles.PopoverArrow} />
        </HoverOverPrimitive.Content>
      </HoverOverPrimitive.Portal>
    </HoverOverPrimitive.Root>
  );
};

export default HoverOver;
